import * as React from 'react';
import clsx from 'clsx';

import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { addBookmark, removeBookmark, selectBookmarkedProductIds } from 'ducks/client/bookmarks';

import { BookingWidgetThemeContext } from 'contexts/BookingWidgetThemeContext';
import { getThemeCssOverride } from 'components/Themes';

type Props = {
  productId: string;
};

export const ProductDetailsBookmarkButton = ({ productId }: Props) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const bookmarks = useSelector(selectBookmarkedProductIds);
  const isBookmarked = bookmarks.includes(productId);

  const bookingWidgetTheme = React.useContext(BookingWidgetThemeContext);

  return (
    <div
      className={clsx(
        'base-single__headerinfo__other__favo',
        getThemeCssOverride(bookingWidgetTheme, 'maininfo__other__bookmark')
      )}
    >
      <label>
        <input
          type="checkbox"
          onClick={(e) => e.stopPropagation()}
          onChange={() => {
            isBookmarked ? dispatch(removeBookmark(productId)) : dispatch(addBookmark(productId));
          }}
          checked={isBookmarked}
        />
        <img className="on" src="/static/images/ic_favo_on.svg" alt="favorite on" />
        <img className="off" src="/static/images/ic_favo_off.svg" alt="favorite off" />
        <p>{t('Bookmarked')}</p>
      </label>
    </div>
  );
};
